// Admin → Blog — layout route. M5.
//
// ⚠️ `_authed.blog.$id` nests under this file, so it MUST render an <Outlet/>
// or the child never mounts and /blog/$id silently renders the LIST instead of
// the editor. That bug shipped four times (pages, families, schools, users,
// content) before it was found on 2026-08-15 — the list therefore lives in
// `_authed.blog.index.tsx` from the start, not here.
//
// Verify in routeTree.gen.ts: both the index and the $id child must declare
// `getParentRoute: () => AuthedBlogRoute`.

import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/blog')({
  component: () => <Outlet />,
});
